import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { AppConfig } from '../../../app.settings';
import { MonitorKey } from '../../models/view-models/monitor-models/monitor-key.type';

@Injectable()
export class PlayerService {
  private endpoint: string;

  constructor(public http: HttpClient, config: AppConfig) {
    this.endpoint = config.getConfig('api') + 'Player/';
  }

  startPlaylist(handler: string, machinePhysicalAddress: string, playlistId: number, shouldWaitUntilAssigned?: boolean) {

    const body = {
      MachinePhysicalAddress: machinePhysicalAddress,
      MonitorHandler: handler,
      IdPlaylist: playlistId,
      ShouldWaitUntilAssigned: shouldWaitUntilAssigned
    };

    return this.http.post(this.endpoint + 'StartPlaylistOnMonitor', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  startAssignedPlaylist(handler: string, machinePhysicalAddress: string) {
    const body: MonitorKey = {
      MachinePhysicalAddress: machinePhysicalAddress,
      MonitorHandler: handler
    };

    return this.http.post(this.endpoint + 'StartAssignedPlaylist', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  stopPlaylist(handler: string, machinePhysicalAddress: string) {

    const body: MonitorKey = {
      MachinePhysicalAddress: machinePhysicalAddress,
      MonitorHandler: handler
    };

    return this.http.post(this.endpoint + 'StopPlaylistOnMonitor', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  refreshPlaylist(handler: string, machinePhysicalAddress: string) {

    const body: MonitorKey = {
      MachinePhysicalAddress: machinePhysicalAddress,
      MonitorHandler: handler
    };

    return this.http.post(this.endpoint + 'RefreshContentOnMonitor', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  playForward(handler: string, machinePhysicalAddress: string) {

    const body: MonitorKey = {
      MachinePhysicalAddress: machinePhysicalAddress,
      MonitorHandler: handler
    };

    return this.http.post(this.endpoint + 'ForwardOnMonitor', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  playBackward(handler: string, machinePhysicalAddress: string) {

    const body: MonitorKey = {
      MachinePhysicalAddress: machinePhysicalAddress,
      MonitorHandler: handler
    };

    return this.http.post(this.endpoint + 'BackwardOnMonitor', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  startPlaylistOnAllAssignedMonitors(idPlaylist: number) {
    return this.http.post(this.endpoint + 'StartPlaylistOnAllAssignedMonitors', idPlaylist, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  startAssignedPlaylistOnAllMonitors(body: MonitorKey[], shouldWaitUntilAssigned?: boolean) {
    const params = new HttpParams()
      .set('shouldWaitUntilAssigned', shouldWaitUntilAssigned);

    return this.http.post(this.endpoint + 'StartAssignedPlaylistForAllMonitors', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params
    });
  }

  stopPlaylistOnAllMonitors(body: MonitorKey[]): Observable<void> {
    return this.http.post<void>(this.endpoint + 'StopPlaylistOnAllMonitors', body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  stopPlaylistsOnAllAssignedMonitors(playlistsIds: number[]): Observable<void> {
    return this.http.post<void>(this.endpoint + 'StopPlaylistsOnAllAssignedMonitors', playlistsIds, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  cleanMachineOrMonitor(body: MonitorKey): Observable<any> {
    return this.http.post(`${this.endpoint}CleanMonitor`, body);
  }

  public startAssignedPlaylistForAllMonitorsWithDelay(monitorTagId: number, delay: number): Observable<void> {
    return this.http.post<void>(`${this.endpoint}StartAssignedPlaylistForAllMonitorsWithDelay`, { monitorTagId, delay });
  }
}
